const prefix = 'DemandRecommendation';

export enum DemandRecommendationMeasures {
  RECOMMENDATIONS_COUNT = `${prefix}.recommendationsCount`,
  DEMANDS_COUNT = `${prefix}.demandsCount`,
  DEMANDS_WITH_RECOMMENDATIONS_COUNT = `${prefix}.demandsWithRecommendationsCount`,
  PERCENTAGE_RECOMMENDATIONS = `${prefix}.percentageRecommendation`,
}

export enum DemandRecommendationDimensions {
  CREATED_AT = `${prefix}.createdAt`,
}
